import routes from './permission.routes';

export const permissionModule = {
    routes
};